import React, { useEffect } from "react";
import { FaCode, FaPaintBrush, FaServer, FaTools, FaLightbulb } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Skills.css";

function Skills() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  const skills = [
    {
      icon: <FaCode />,
      title: "Frontend Development",
      items: [
        { name: "HTML", level: 95 },
        { name: "CSS", level: 95 },
        { name: "JavaScript", level: 85 },
        { name: "React.js", level: 85 },
        { name: "Tailwind CSS", level: 80 },
      ],
    },
    {
      icon: <FaPaintBrush />,
      title: "UI/UX Design",
      items: [
        { name: "Figma", level: 85 },
        { name: "Wireframing", level: 80 },
        { name: "Prototyping", level: 70 },
        { name: "User-Centered Design", level: 70 },
      ],
    },
    {
      icon: <FaServer />,
      title: "Backend Development",
      items: [
        { name: "Node.js", level: 70 },
        { name: "Express.js", level: 70 },
        { name: "Firebase", level: 85 },
        
      ],
    },
    {
      icon: <FaTools />,
      title: "Automation & Tools",
      items: [
        { name: "Python (Bots)", level: 70 },
        { name: "Telegram Bot API", level: 85 },
        { name: "RapidAPI", level: 70 },
        { name: "Git & GitHub", level: 85 },
      ],
    },
    {
      icon: <FaLightbulb />,
      title: "Product & Strategy",
      items: [
        { name: "Product Ideation", level: 95 },
        { name: "MVP Development", level: 85 },
        { name: "Landing Pages", level: 85 },
        { name: "Marketing Strategy", level: 70 },
      ],
    },
  ];

  return (
    <section id="skills" className="skills">
      <h2>My Skills</h2>
      <p className="skills-description">
        A blend of frontend development, UI/UX design, backend integration, and automation to build modern, scalable products.
      </p>

      <div className="skills-container">
        {skills.map((category, index) => (
          <div
            className="skill-category"
            data-aos="fade-up"
            data-aos-delay={index * 100}
            key={index}
          >
            <h3>
              {category.icon} {category.title}
            </h3>
            <div className="skill-list">
              {category.items.map((skill, i) => (
                <div className="skill" key={i}>
                  <div className="skill-name">{skill.name}</div>
                  <div
                    className="skill-bar-container"
                    role="progressbar"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    aria-valuenow={skill.level}
                    aria-label={`${skill.name} skill level`}
                  >
                    <div
                      className="skill-bar"
                      style={{ width: `${skill.level}%` }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Skills;
// This code defines a Skills component that displays various skill categories with their respective skills and proficiency levels.